module.exports = __webpack_public_path__ + "img/chr_ts_90_1.3cdf3a3e.png";